import React from 'react';
import { ICardsProps, CARDTYPE, determineFallbackImg, isSeries } from '@ifit/mp-card-utilities';
import NativeClick, { METHODS } from '@ifit/mp-native-click';
import LazyLoad from '@ifit/mp-cards-lazy-load';
import SeriesCard from '@ifit/mp-series-card';
import TrainerCard from '@ifit/mp-trainer-card';
import WorkoutCard from '@ifit/mp-workout-card';
import './index.scss';

export const PureCardType = (props: ICardsProps) => {
  const {
    cardSize,
    cardType,
    data,
    horizontal,
    category,
    programInfo,
    disableNative,
    verbose,
    locked,
    useMetricUnits,
    overlayText,
    isChallenge,
    equipmentType,
  } = props;
  const { workoutType, image } = data;
  const fallbackImage = determineFallbackImg(workoutType, cardType);
  //use our own fallback images instead of lycan generated ones if it's not at img.ifit.com
  const isLycanGeneratedFallback = image?.indexOf('img.ifit.com') === -1;
  const forceFallbackImg = isLycanGeneratedFallback;

  let cardRendered;
  switch (cardType) {
    case CARDTYPE.SERIES:
      cardRendered = (
        <SeriesCard
          cardSize={cardSize}
          data={data}
          programInfo={programInfo}
          locked={locked}
          fallbackImage={fallbackImage}
          forceFallbackImg={forceFallbackImg}
          isChallenge={isChallenge}
        />
      );
      break;
    case CARDTYPE.TRAINER:
      cardRendered = (
        <TrainerCard
          cardSize={cardSize}
          data={data}
          fallbackImage={fallbackImage}
          forceFallbackImg={forceFallbackImg}
        />
      );
      break;
    default:
      cardRendered = (
        <WorkoutCard
          cardSize={cardSize}
          data={data}
          programInfo={programInfo}
          disableNative={disableNative}
          verbose={verbose}
          locked={locked}
          overlayText={overlayText}
          horizontal={horizontal}
          category={category}
          useMetricUnits={useMetricUnits}
          fallbackImage={fallbackImage}
          forceFallbackImg={forceFallbackImg}
          equipmentType={equipmentType}
        />
      );
  }
  return (
    <LazyLoad
      cardSize={cardSize}
      cardType={cardType}
      isHorizontal={horizontal}
    >
      {cardRendered}
    </LazyLoad>
  );
};

export const PureCard = PureCardType;

const NativeCard = (props: ICardsProps) => {
  const { data, programInfo, disableNative, cardType } = props;
  const clickMethod =
    isSeries(cardType) ? METHODS.programSelected : METHODS.workoutSelected;
  const objectToSend = clickMethod(
    data.itemId,
    programInfo ? programInfo.seriesId : data.programId
  );
  return (
    <NativeClick
      disableNative={disableNative}
      verbose={props.verbose}
      objectToSend={objectToSend}
    >
      <PureCard {...props} />
    </NativeClick>
  );
};


export default NativeCard;
